var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg81NotCovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84658",
    "data-name": "Group 84658",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.254,
    height: 80.235,
    viewBox: "0 0 80.254 80.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_240153",
    "data-name": "Path 240153",
    d: "M128.31,16.264a35.715,35.715,0,0,1,5.877-8.555l-3.115-3.118a39.992,39.992,0,0,0-10.71,25.988l4.316-.022a34.82,34.82,0,0,1,1.978-10.3,2.571,2.571,0,0,1,.65-3.577,2.608,2.608,0,0,1,1-.415",
    transform: "translate(-120.361 8.111)",
    fill: "#8e8e8e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240154",
    "data-name": "Path 240154",
    d: "M124.458,11.886l19.99,10.752a12.41,12.41,0,0,1,3.027-6.729l-22.092-6.3a1.235,1.235,0,0,0-.924,2.274",
    transform: "translate(-114.262 16.899)",
    fill: "#8e8e8e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240155",
    "data-name": "Path 240155",
    d: "M135.032,22.692l1.3-1.923a2.648,2.648,0,0,1,3.674-.714,2.616,2.616,0,0,1,.714.714l1.3,1.92a5.733,5.733,0,1,0-8.04-1.046,5.672,5.672,0,0,0,1.046,1.046Z",
    transform: "translate(-98.392 21.93)",
    fill: "#8e8e8e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240156",
    "data-name": "Path 240156",
    d: "M128.014,51.057H171a1.433,1.433,0,0,0,1.187-2.236L150.693,17.145a1.433,1.433,0,0,0-1.989-.385,1.413,1.413,0,0,0-.385.385L126.83,48.822a1.433,1.433,0,0,0,1.184,2.236m20.059-27.233a1.433,1.433,0,1,1,2.866,0V39.592a1.433,1.433,0,1,1-2.866,0Zm0,21.5a1.433,1.433,0,1,1,2.866,0v1.433a1.433,1.433,0,1,1-2.866,0Z",
    transform: "translate(-109.369 29.178)",
    fill: "#ffb164"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240157",
    "data-name": "Path 240157",
    d: "M158.15,30.557A39.91,39.91,0,0,0,147.457,4.591L144.4,7.654a35.655,35.655,0,0,1,9.451,22.873Z",
    transform: "translate(-77.896 8.111)",
    fill: "#8e8e8e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240158",
    "data-name": "Path 240158",
    d: "M161.346,10.68A40.017,40.017,0,0,0,135.386,0V4.3a35.726,35.726,0,0,1,22.9,9.44Z",
    transform: "translate(-93.816)",
    fill: "#8e8e8e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240159",
    "data-name": "Path 240159",
    d: "M150.927,4.319V0a40.032,40.032,0,0,0-25.96,10.68l3.115,3.115a35.9,35.9,0,0,1,22.845-9.476",
    transform: "translate(-112.224)",
    fill: "#8e8e8e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg81NotCovered);
export default __webpack_public_path__ + "static/media/8.1_Not_Covered.bfdbbafe83ac6fd9e9489621e57a21b7.svg";
export { ForwardRef as ReactComponent };